var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#00BB8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0832 20.5L11.3124 13.563C11.1395 12.0067 12.7412 10.8643 14.1563 11.5347L29.2674 18.6925C30.7925 19.4149 30.7925 21.5851 29.2674 22.3075L14.1563 29.4653C12.7412 30.1357 11.1395 28.9933 11.3124 27.437L12.0832 20.5ZM12.0832 20.5H20.2498",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMessage);
export default __webpack_public_path__ + "static/media/greenMessage.134c2b7b3e43d45794efa37c1277873e.svg";
export { ForwardRef as ReactComponent };